import WaypointIcon from '@porterin/booking-flow/src/order-review/view/components/WaypointIcon';
import { useLocation } from '@porterin/component-library/src/location-accuracy//contexts/LocationContext';
import React from 'react';

export const MapWaypointCityLabelCmp: React.FC = () => {
  const { state } = useLocation();

  return (
    <div className="flex items-center">
      <WaypointIcon waypoint={state.waypoint} />
      <span
        data-testid="waypoint-city"
        className="ml-2 font-semibold
          text-[1.8rem] leading-[2rem] text-[#2d2f34]"
      >
        {state.address?.addressDetails.city}
      </span>
    </div>
  );
};
